import { useEffect, useState } from "react";
import { resolveThumbnailSrc, FALLBACK_IMAGE } from "../lib/cloudinary";

const EMPTY_VIDEO_IDS = [];

export default function MediaImage({
  publicId,
  cover,
  videoIds = EMPTY_VIDEO_IDS,
  alt = "",
  className = "",
  eager = false,
}) {
  const [src, setSrc] = useState(() => resolveThumbnailSrc(publicId, cover, videoIds));

  useEffect(() => {
    setSrc(resolveThumbnailSrc(publicId, cover, videoIds));
  }, [publicId, cover, videoIds]);

  const handleError = () => {
    setSrc((current) => (current === FALLBACK_IMAGE ? current : FALLBACK_IMAGE));
  };

  return (
    <img
      src={src}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      referrerPolicy="no-referrer"
      onError={handleError}
      className={className}
    />
  );
}
